<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKey"
              @keyup.enter="clickQuery"
              type="search"
              placeholder="输入关键字快速搜索..."
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="visible = !visible"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="clickQuery">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="formLoad('fabricRequest')"
              v-if="allow('A')"
            >
              {{ $l('btn_applicatio_form') || '申请单入库' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="visible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$l('table_head_status') || '状态'">
              <el-checkbox-group
                v-model="form.fabricStockInStatusArr"
                size="small"
              >
                <el-checkbox label="N" name="type">{{
                  $l('search_label_status_N') || '新增'
                }}</el-checkbox>
                <el-checkbox label="Y" name="type">{{
                  $l('search_label_status_Y') || '已审核'
                }}</el-checkbox>
                <el-checkbox label="D" name="type">{{
                  $l('search_label_status_D') || '已删除'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_bill_name') || '业务员'"
              prop="fabricAgentCode"
            >
              <dict-select
                v-model="form.fabricAgentCode"
                url="/digitalCenter/common/dict/baseUser"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                :multiple="false"
                clearable
                :options="{ label: 'label', value: 'code' }"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_supplier') || '供应商'"
             
            >
              <dict-select
                clearable
                filterable
                style="width: 100%"
                size="small"
                v-model="form.scmCode"
                url="/master/common/dict/scmCooperated"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_fabric_name') || '面料'"
              prop="fabricDescriptionArray"
              ><el-select
                v-model="form.fabricDescriptionArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in fabricDescriptionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_fabric_number') || '面料编号'"
              prop="fabricNo"
            >
              <el-input
                v-model="form.fabricNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="50"
                clearable
                size="small"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_flowerType') || '花型'"
              prop="patternArray"
            >
              <el-select
                v-model="form.patternArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in patternOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"
            ><el-form-item
              :label="$l('form_label_technology') || '工艺'"
              prop="techniqueArray"
            >
              <el-select
                v-model="form.techniqueArray"
                multiple
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in techniqueOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"> </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_materialNotes') || '材料备注'"
              prop="constructionArray"
            >
              <el-select
                v-model="form.constructionArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in constructionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_function') || '功能'"
              prop="functionArray"
            >
              <el-select
                v-model="form.functionArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in functionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_fabric_width') || '有效门幅'"
              >
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.widStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.widEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item prop="widUnit">
                    <dict-select
                      v-model="form.widUnit"
                      url="/digitalCenter/common/dict/biz"
                      :body="{ dictType: 'widUnit' }"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      size="small"
                      style="width: 100%"
                      filterable
                      clearable
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_fabric_weight') || '面料克重'"
              >
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="1"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.fabricWeightStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="1"
                    :step="1"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.fabricWeightEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <dict-select
                      v-model="form.fabricWeightUnit"
                      url="/digitalCenter/common/dict/biz"
                      :body="{ dictType: 'fabricWeightUnit' }"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      size="small"
                      style="width: 100%"
                      filterable
                      clearable
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('INDEX.create_date') || '创建日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateBegin"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.table_label_modification_date') || '修改日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateBegin"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消查询</el-button>
        <el-button size="small" type="warning" @click="onReset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="clickQuery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      dialogVisible: false,
      form: {
        searchKey: '',
        fabricNo: '',
        fabricName: '',
        fabricStockInNo: '',
        fabricAgentCode: '',
        scmCode: '',
        createDateBegin: '',
        createDateEnd: '',
        modifyDateBegin: '',
        modifyDateEnd: '',
        fabricStockInStatusArr: ['Y', 'N'],
        functionArray: [], //功能
        constructionArray: [], //材料备注
        fabricDescriptionArray: [], //面料名称
        patternArray: [], //花型
        techniqueArray: [] //工艺
      },
      functionOptions: [], //功能
      constructionOptions: [], //材料备注
      fabricDescriptionOptions: [], //面料名称
      patternOptions: [], //花型
      techniqueOptions: [] //工艺
    }
  },
  mounted() {
    this.onReset()
  },
  activated() {
    this.query()
  },
  methods: {
    formLoad(type) {
      this.$emit('formLoad', type)
    },
    clickQuery() {
      this.$emit('reset')
      this.query()
    },
    closeDialog() {
      this.visible = false
    },
    query() {
      this.$emit('submit', this.form)
      this.visible = false
    },
    onReset() {
      this.form = {
        searchKey: '',
        fabricStockInStatusArr: ['Y', 'N'],
        functionArray: [],
        constructionArray: [],
        fabricDescriptionArray: [],
        patternArray: [],
        techniqueArray: []
      }
      this.clickQuery()
      this.loadCategoryData()
    },
    loadCategoryData() {
      //功能
      this.$api
        .masterFabricAttributes_attributesSelect({
          fabricAttrTypeEn: 'Function'
        })
        .then((res) => {
          this.functionOptions = res.body.data
        })
        .catch(() => {})
      //材料备注
      this.$api
        .masterFabricAttributes_attributesSelect({
          fabricAttrTypeEn: 'Construction'
        })
        .then((res) => {
          this.constructionOptions = res.body.data
        })
        .catch(() => {})
      //面料名称
      this.$api
        .masterFabricAttributes_attributesSelect({
          fabricAttrTypeEn: 'Fabric Description'
        })
        .then((res) => {
          this.fabricDescriptionOptions = res.body.data
        })
        .catch(() => {})
      //花型
      this.$api
        .masterFabricAttributes_attributesSelect({
          fabricAttrTypeEn: 'Pattern'
        })
        .then((res) => {
          this.patternOptions = res.body.data
        })
        .catch(() => {})
      //工艺
      this.$api
        .masterFabricAttributes_attributesSelect({
          fabricAttrTypeEn: 'Technique'
        })
        .then((res) => {
          this.techniqueOptions = res.body.data
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
